import type { MailFolderRole } from "../../common/api/types.js";

/** Was die Liste zeigt: ein Ordner nach Rolle oder alle markierten Nachrichten. */
export type MailView = Exclude<MailFolderRole, "junk"> | "starred";

export const MAIL_VIEWS: ReadonlyArray<{ id: MailView; label: string }> = [
  { id: "inbox", label: "Posteingang" },
  { id: "starred", label: "Markiert" },
  { id: "sent", label: "Gesendet" },
  { id: "drafts", label: "Entwürfe" },
  { id: "archive", label: "Archiv" },
  { id: "trash", label: "Papierkorb" },
];

export function viewLabel(view: MailView): string {
  return MAIL_VIEWS.find((entry) => entry.id === view)?.label ?? "Posteingang";
}
